import { BaseApiClient } from './base-client'
import { API_ROUTES, ApiResponse } from '@super/shared-types'
import { withErrorHandling } from '../utils'

export interface FeatureFlagsResponse {
  featureFlags: string[]
  organizationId: string | null
}

export class FeatureFlagsApiClient extends BaseApiClient {
  async getFeatureFlags(): Promise<FeatureFlagsResponse | null> {
    return withErrorHandling(
      async () => {
        const response = await this.request<ApiResponse<FeatureFlagsResponse>>(
          API_ROUTES.FEATURE_FLAGS.GET,
        )
        return response.data || null
      },
      {
        onApiError: 'log-and-return-null',
        onOtherError: 'log-and-return-null',
        errorContext: 'Error fetching feature flags',
      },
    )
  }
}

export const featureFlagsApiClient = new FeatureFlagsApiClient()
